import React, { useEffect, useRef } from 'react';

const drawerTransitionStyles = `
  .drawer-backdrop {
    transition: opacity 0.3s ease-in-out;
  }
  .drawer-panel-itself {
    transition: transform 0.3s ease-in-out;
  }
`;

function Drawer({
    isOpen,
    onClose,
    title,
    children,
    panelContainerClassName = "max-w-md",
    mainPanelClassName = "flex h-full flex-col overflow-y-auto bg-white py-6 shadow-xl"
}) {
    const drawerPanelRef = useRef(null);

    // ESC to close
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape') onClose();
        };
        if (isOpen) document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);

    // Lock scroll when open
    useEffect(() => {
        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);

    return (
        <>
            <style>{drawerTransitionStyles}</style>
            {/* Backdrop */}
            <div
                className={`drawer-backdrop fixed inset-0 bg-gray-500 bg-opacity-75 z-[9998] transition-opacity duration-300 ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                onClick={onClose}
            />
            {/* Drawer */}
            <div className={`drawer-panel-itself fixed inset-y-0 right-0 z-[9999] flex max-w-full pl-10 transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <div className={`w-screen ${panelContainerClassName}`}>
                    <div className={mainPanelClassName}>
                        {/* Header */}
                        <div className="px-4 sm:px-6">
                            <div className="flex items-start justify-between">
                                <h2 id="slide-over-title" className="text-lg font-semibold leading-6 text-gray-900">
                                    {title}
                                </h2>
                                <div className="ml-3 flex h-7 items-center">
                                    <button
                                        type="button"
                                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                                        onClick={onClose}
                                    >
                                        <span className="absolute -inset-2.5" />
                                        <span className="sr-only">Close panel</span>
                                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* Content */}
                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Drawer;